module.exports = __webpack_public_path__ + "img/18.57491426.jpg";